<template>
  <input :class="class" :id="identifier" :name="identifier" :type="type" v-model="value" />
</template>
<script lang="ts" src="@/library/templates/default/controls/FormInput.ts"></script>
